<template>
    <div>
        <img v-if="tool === 0" class="qualification_page__content_main_img" src="/i/pages/qualification/main.webp" />
        <!-- Комплексный анализ конкурента -->
        <div v-else-if="tool === 1">
            <Stepper :pt="{nav: {class: 'hidden'}}">
                <StepperPanel>
                    <template #content="{ nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.concurents.slide_1_title') }}</h4>
                        <p>{{ $t('lang.pages.qualification.tool.concurents.slide_1_desc') }}</p>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/1-1.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback, nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.concurents.slide_2_title') }}</h4>
                        <p>{{ $t('lang.pages.qualification.tool.concurents.slide_2_desc') }}</p>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/1-2.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback, nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.concurents.slide_3_title') }}</h4>
                        <p>{{ $t('lang.pages.qualification.tool.concurents.slide_3_desc') }}</p>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/1-3.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback, nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.concurents.slide_4_title') }}</h4>
                        <p>{{ $t('lang.pages.qualification.tool.concurents.slide_4_desc') }}</p>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/1-4.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.concurents.slide_5_title') }}</h4>
                        <p>{{ $t('lang.pages.qualification.tool.concurents.slide_5_desc') }}</p>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/1-5.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
            </Stepper>
        </div>
        <!-- Аналитика в поиске -->
        <div v-else-if="tool === 2">
            <Stepper :pt="{nav: {class: 'hidden'}}">
                <StepperPanel>
                    <template #content="{ nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.seo.slide_1_title') }}</h4>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/2-1.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback, nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.seo.slide_2_title') }}</h4>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/2-2.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback, nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.seo.slide_3_title') }}</h4>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/2-3.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.seo.slide_4_title') }}</h4>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/2-4.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
            </Stepper>
        </div>
        <!-- Аналитика по ссылкам -->
        <div v-else-if="tool === 3">
            <Stepper :pt="{nav: {class: 'hidden'}}">
                <StepperPanel>
                    <template #content="{ nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.links.slide_1_title') }}</h4>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/3-1.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback, nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.links.slide_2_title') }}</h4>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/3-2.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback, nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.links.slide_3_title') }}</h4>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/3-3.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.links.slide_4_title') }}</h4>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/3-4.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
            </Stepper>
        </div>
        <!-- Семантическое ядро -->
        <div v-else-if="tool === 4">
            <Stepper :pt="{nav: {class: 'hidden'}}">
                <StepperPanel>
                    <template #content="{ nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.semantic.slide_1_title') }}</h4>
                        <p>{{ $t('lang.pages.qualification.tool.semantic.slide_1_desc') }}</p>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/4-1.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback, nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.semantic.slide_2_title') }}</h4>
                        <p>{{ $t('lang.pages.qualification.tool.semantic.slide_2_desc') }}</p>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/4-2.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback, nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.semantic.slide_3_title') }}</h4>
                        <p>{{ $t('lang.pages.qualification.tool.semantic.slide_3_desc') }}</p>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/4-3.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.semantic.slide_4_title') }}</h4>
                        <p>{{ $t('lang.pages.qualification.tool.semantic.slide_4_desc') }}</p>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/4-4.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
            </Stepper>
        </div>
        <!-- Аналитика по рекламе -->
        <div v-else-if="tool === 5">
            <Stepper :pt="{nav: {class: 'hidden'}}">
                <StepperPanel>
                    <template #content="{ nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.ads.slide_1_title') }}</h4>
                        <p>{{ $t('lang.pages.qualification.tool.ads.slide_1_desc') }}</p>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/5-1.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.ads.slide_2_title') }}</h4>
                        <p>{{ $t('lang.pages.qualification.tool.ads.slide_2_desc') }}</p>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/5-2.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
            </Stepper>
        </div>
        <!-- Аналитика по Дзену -->
        <div v-else-if="tool === 6">
            <Stepper :pt="{nav: {class: 'hidden'}}">
                <StepperPanel>
                    <template #content="{ nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.dzen.slide_1_title') }}</h4>
                        <p>{{ $t('lang.pages.qualification.tool.dzen.slide_1_desc') }}</p>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/6-1.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback, nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.dzen.slide_2_title') }}</h4>
                        <p>{{ $t('lang.pages.qualification.tool.dzen.slide_2_desc') }}</p>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/6-2.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.dzen.slide_3_title') }}</h4>
                        <p>{{ $t('lang.pages.qualification.tool.dzen.slide_3_desc') }}</p>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/6-3.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
            </Stepper>
        </div>
        <!-- Аналитика по нейросетям (AI) -->
        <div v-else-if="tool === 8">
            <Stepper :pt="{nav: {class: 'hidden'}}">
                <StepperPanel>
                    <template #content="{ nextCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.ai.slide_1_title') }}</h4>
                        <p>{{ $t('lang.pages.qualification.tool.ai.slide_1_desc') }}</p>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/8-1.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-next="nextCallback"
                        />
                    </template>
                </StepperPanel>
                <StepperPanel>
                    <template #content="{ prevCallback }">
                        <h4>{{ $t('lang.pages.qualification.tool.ai.slide_2_title') }}</h4>
                        <p>{{ $t('lang.pages.qualification.tool.ai.slide_2_desc') }}</p>
                        <video controls autoplay muted class="w-full">
                            <source src="https://keys-so-video.keys.so/video/qualification/8-2.mp4">
                        </video>
                        <QualificationStepsNavigationContent
                            :callback-prev="prevCallback"
                        />
                    </template>
                </StepperPanel>
            </Stepper>
        </div>
        <div v-else-if="tool === 7" class="qualification_page__tool_other_container">
            <h4>{{ $t('lang.pages.qualification.tool.other.slide_title') }}</h4>
            <div class="grid">
                <div class="col-12 lg:col-6">
                    <div class="field mb-0">
                        <TemplatesLabelCounts text="" :count="getCount" :limit="maxOtherToolLength" />
                        <Textarea
                            :value="getOther"
                            rows="8"
                            @keyup="onUpdateOther"
                        />
                    </div>
                </div>
                <div class="col-6 hidden lg:block relative">
                    <img src="/i/pages/qualification/tool-7.webp" alt="" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Stepper from "primevue/stepper";
import StepperPanel from "primevue/stepperpanel";
import Button from "primevue/button";
import QualificationStepsNavigationContent from "./StepsNavigationContent.vue";
import Textarea from "primevue/textarea";
import TemplatesLabelCounts from "../../../templates/LabelCounts.vue";
import {Constants} from "../constants/constants";

export default {
    name: "StepsToolContent",
    emits: ['update:other'],
    props: {
        tool: {
            type: Number,
            required: true,
        },
        other: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            maxOtherToolLength: Constants.MAX_USER_INPUTS_LENGTH,
        }
    },
    computed: {
        getCount() {
            return this.other.length;
        },
        getOther() {
            return this.other;
        },
    },
    methods: {
        onUpdateOther(e) {
            this.$emit('update:other', e.target.value)
        }
    },
    components: {
        TemplatesLabelCounts,
        Button,
        Stepper,
        StepperPanel,
        QualificationStepsNavigationContent,
        Textarea,
    }
}
</script>

<style scoped>
.qualification_page__tool_other_container {
    color: #4b5563;
}
.qualification_page__tool_other_container img {
    width: 125%;
    position: absolute;
    top: 50%;
}
video {
    aspect-ratio: 16 / 9;
}
</style>
